import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';


import { AppComponent } from './app.component';
import {AppContactDetailsComponent} from './contact-details/app-contact-details.component';
import {AppPersonalInformationComponent} from './personal-information/app-personal-information.component';
import {AppCreditorDetailsComponent} from './creditor-details/app-creditor-details.component';
import {AppSubmissionComponent} from './submission/app-submission.component';
import {AppBasicDetailsComponent} from './basic-details/app-basic-details.component';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import { ValidPhoneNumberDirective } from './shared/valid-phone-number.directive';
import {ValidPostcodeDirective} from './shared/valid-postcode.directive';


@NgModule({
  declarations: [
    AppComponent,
    AppBasicDetailsComponent,
    AppContactDetailsComponent,
    AppPersonalInformationComponent,
    AppCreditorDetailsComponent,
    AppSubmissionComponent,
    // Validators
    ValidPhoneNumberDirective,
    ValidPostcodeDirective,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    RouterModule.forRoot([])
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/app.module.ts